import React from 'react';
import MaskedInput from 'src/ui/library/MaskedInput/MaskedInput';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const percentMask = rawValue => {
  let numberMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalLimit: 2,
    requireDecimal: true,
    includeThousandsSeparator: false,
    allowLeadingZeroes: false,
  });
  rawValue = isNaN(parseFloat(rawValue)) ? '0' : rawValue;
  rawValue = rawValue.indexOf('.') === 0 ? 0 + rawValue : rawValue;
  let mask = numberMask(rawValue);
  let decimalsRegex = /\.([0-9]{1,2})/;
  let result = decimalsRegex.exec(rawValue);
  // In case there is only one decimal
  if (result && result[1].length < 1) {
    mask.push('0');
  } else if (!result) {
    mask.push('0');
  }
  return mask;
};

//function for handling decimal places.
const percentageBlur = (props, event) => {
  let mask = event.target.value;
  // in case value is inputted then check for decimal places.
  if (mask) {
    const decimalsRegex = /\.([0-9]{1,2})/;
    const result = decimalsRegex.exec(event.target.value);

    // In case there is only one decimal
    if (result && result[1].length < 2) {
      mask += '0';
    } else if (!result) {
      // in case user didn't input a decimal then add decimal also
      if (mask.indexOf('.') === -1) mask += '.00';
      // else add decimal places
      else mask += '00';
    }

    //pass back the changed value to save in state
    if (props.onChange) {
      props.onChange({ target: { value: mask } });
    }
  }
  //pass event to existing blur if defined.
  if (props.onBlur) {
    props.onBlur(event);
  }
};

const setInputRef = (maskedInputRef, inputRef, forwardedRef) => {
  const inputElement = maskedInputRef ? maskedInputRef.inputElement : null;

  if (typeof inputRef === 'function') {
    inputRef(inputElement);
  }

  if (typeof forwardedRef === 'function') {
    forwardedRef(inputElement);
  } else if (forwardedRef) {
    forwardedRef.current = inputElement;
  }
};

const PercentageMask = React.forwardRef((props, ref) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      onBlur={percentageBlur.bind(this, props)}
      ref={maskedInputRef => setInputRef(maskedInputRef, inputRef, ref)}
      mask={percentMask}
      guide={false}
      showMask
    />
  );
});

PercentageMask.displayName = 'PercentageMask';

PercentageMask.propTypes = {
  inputRef: PropTypes.func,
};

export default PercentageMask;
